class ShellController {
  constructor() {
    this.name = 'shell';
  }
}

export default ShellController;



// WEBPACK FOOTER //
// ./client/app/common/layout/shell/shell.controller.js